<div class="pae-box">
  <span class="pae-x-label">Scored residue</span>
  <span class="pae-y-label">Aligned residue</span>
  <div class="pae-axis-box"></div>
  <div class="pae-img-box">
    <div class="pae-img-box-border">
      <div id="paeviewer" style="aspect-ratio: 1;"></div>
    </div>
   
  </div>
  <img alt="paescale" class="pae-scale-img-h" src="../../assets/img/horizontal_colorbar.png">
  <ul class="pae-scale-ticks-h">
    <li>0</li>
    <li>5</li>
    <li>10</li>
    <li>15</li>
    <li>20</li>
    <li>25</li>
    <li>30</li>
  </ul>
  <span class="pae-scale-label">Expected position error (&Aring;ngstr&ouml;ms)</span>

</div>